export default () => `
<div class="title-contents card TitleCard">
    <div class="TitleHeaderBar"></div>

    <div class="CoverImage"></div>

    <div class="InfoPanel">
        <div class="TitleInfo"></div>

        <div class="TitleAction is-grid"></div>

        <div class="TitleWishlist is-grid"></div>
    </div>

    <div class="clear" />
</div>`;
